<template>
    <div>
        <p>Để tiếp tục sử dụng đầy đủ các tính năng <strong>(như thanh toán / nhận tiền)</strong>, vui lòng cập nhật thông tin tài khoản ngân hàng của bạn.</p>
        <div class="justify-content-center d-flex">
            <el-button class="bg-violet text-white" @click="action()">Xác nhận</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "CompleteBankAccountDialog",
    data()
    {
        return {
            publicPath: process.env.VUE_APP_BASE_URL,
        }
    },
    methods: {
        action()
        {
            window.open(this.publicPath + 'profile?active=1');
        }
    }
}
</script>

<style scoped>

.bg-violet {
    background: blueviolet;
}
</style>